import type { NormalizedAsset } from '@/types/assets';

export const formatAssetDisplay = (asset: any, source: string): NormalizedAsset => {
  switch (source) {
    case 'stock_fundamentals':
      return {
        id: asset.id,
        name: asset.name,
        code: asset.code,
        assetType: 'stock',
        source: 'stock_fundamentals',
        exchange: asset.exchange,
        country: asset.country,
      } as NormalizedAsset;

    case 'funds_raw':
      return {
        id: asset.id,
        name: asset.fund_name || '',
        code: asset.fund_code || '',
        assetType: 'fund_raw',
        source: 'funds_raw',
        company: asset.company_name,
        assetClass: asset.sa_asset_class,
        managementCompanyCode: asset.management_company_code,
      } as NormalizedAsset;

    case 'funds':
    default:
      return {
        id: asset.id,
        name: asset.fund_name || '',
        code: asset.fund_code || '',
        assetType: 'fund',
        source: 'funds',
        strategy: asset.investment_strategy,
      } as NormalizedAsset;
  }
};
